export default __webpack_public_path__ + "static/media/tree-main-category.ab14d34c.jpeg";